export default {
  beforeCreate() {
    const shortcuts = this.$options.shortcuts || this.$root?.$shortcuts;
    if (!shortcuts || typeof shortcuts.addKeyMap !== 'function') {
      return;
    }

    const { shortcutsEvents } = this.$options;
    if (!shortcutsEvents) {
      return;
    }

    if (typeof document !== 'undefined') {
      shortcuts.register();
    }
    this._shortcuts = shortcuts;
    const keys = shortcutsEvents.call(this);
    if (keys instanceof Array) {

      this._shortcutsIndexList = keys;
      shortcuts.addKeyMap(keys);
    }
  },
  beforeDestroy() {
    if (this._shortcuts &&
        this._shortcuts.removeKeyMap &&
        this._shortcutsIndexList instanceof Array) {
      this._shortcuts.removeKeyMap(this._shortcutsIndexList);
    }
  }
};
